import { Box, Drawer, Typography } from "@mui/material";
import Logo from "assets/logo.png";
import CopyRight from "components/layout/CopyRight";
import RunsList from "./RunsList";
import CreateSimulation from "./CreateSimulation";
import usePage from "hooks/usePage";

export const runSidebarWidth = 320;

export default function RunListSidebar() {
  const { isUrbanPage, isSharePage } = usePage();

  return (
    <Drawer
      sx={{
        width: runSidebarWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: runSidebarWidth,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "space-between",
          height: "100%",
          transform: "translateX(70px)",
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <Box
        sx={{
          display: "flex",
          padding: "10px 20px",
          alignItems: "center",
          position: "relative",
        }}
      >
        <a
          href="https://www.xyloplan.com/"
          style={{ height: "40px", padding: "4px 0" }}
        >
          <img src={Logo} alt="XyloPlan Logo" style={{ height: "40px" }} />
        </a>
        <Typography
          sx={{
            fontSize: "22px",
            color: "black.main",
            flex: 1,
            textAlign: "center",
          }}
        >
          {isUrbanPage ? "Urban" : "Vegetation"} Pathways
        </Typography>
      </Box>
      {!isSharePage && <CreateSimulation />}
      <Box
        sx={{
          flex: 1,
          padding: "10px 0",
          height: "100%",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <RunsList />
      </Box>
      <CopyRight />
    </Drawer>
  );
}
